import { ocapiClient } from '../../../api-clients/ocapi/client';
import { createOrGetFetchedState } from '../../../utils/fetched-data/create-or-get-fetched-state';
import { generateQueryKey } from '../../../utils/generate-query-key';
import { getCacheDuration } from '../../../utils/get-cache-duration';
import { loadDataFromApi } from '../../../utils/load-data-from-api';
import { paymentDomainStore } from '../store';
/**
 * Loads payment methods for a given query.
 */
export const loadPaymentMethodsForQuery = async (query, reloadCachedData = false) => {
    const queryKey = generateQueryKey(query);
    const state = createOrGetFetchedState(paymentDomainStore.data.paymentMethodsForQuery, queryKey);
    return await loadDataFromApi({
        api: () => ocapiClient.instance.v1.payments.masterData.webPaymentMethods.get(query),
        state,
        cacheDuration: getCacheDuration('paymentMethods'),
        onSuccess: (response) => response.webPaymentMethods,
        reloadCachedData
    });
};
